module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-macbook-landing.2655c1d5.jpg";